<template>
  <auth-template>
    <form @submit.prevent="register">
      <h2>{{ env }}Register</h2>

      <div v-if="isComplete">
        <b-alert variant="info" show>
          <strong>Activation Required</strong>
          <div>
            We have sent you an e-mail to activate your account and set a
            password. Once activated please proceed to
            <span @click="loadLogin">login</span>
          </div>
        </b-alert>

        <hr />

        <div>
          <span @click="loadLogin" class="password-link">Login</span>
        </div>
      </div>

      <div v-else>
        <div class="element">
          <input
            required
            v-model="form.email"
            type="email"
            placeholder="E-mail Address"
          />
        </div>

        <div class="sub-text">
          Once registered we will send you an e-mail to allow you to set an
          account password.
        </div>

        <b-button type="submit" variant="success">Register</b-button>

        <hr />

        <div>
          <span @click="loadLogin" class="password-link"
            >Already have an account?</span
          >
        </div>
      </div>
    </form>
  </auth-template>
</template>

<script>
import { recaptcha } from "@/components/mixins/recaptcha";
import AuthTemplate from "@/views/Auth/AuthTemplate.vue";

export default {
  name: "Register",
  components: { AuthTemplate },
  mixins: [recaptcha],
  data() {
    return {
      loading: false,
      isComplete: false,
      form: {
        email: ""
      }
    };
  },
  computed: {
    env() {
      return process.env.VUE_APP_ENV;
    }
  },
  methods: {
    loadLogin() {
      this.$router.push("/login");
    },
    async register() {
      const title = "Setting up your account";
      const subtitle = "Please wait a moment";
      await this.$store.dispatch("loaderInitiate", { title, subtitle });

      const token = await this.recaptchaToken();

      const email = this.form.email;
      this.$store
        .dispatch("register", { email, token })
        .then(() => {
          this.isComplete = true;
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: err
          });
        })
        .finally(() => {
          this.$store.dispatch("loaderCancel");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.password-link {
  cursor: pointer;
  font-size: 0.8rem;
}

h2 {
  text-align: center !important;
  font-size: 1.4rem !important;
}

h3 {
  font-size: 1.1rem;
}

.sub-text {
  font-size: 0.8rem;
  margin-bottom: 15px;
  color: #777;
}
</style>
